var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeBackgroundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82486 20.98L4.80488 21L4.78391 20.98H2.9909C2.72801 20.9798 2.47597 20.8751 2.29017 20.6891C2.10437 20.5032 2 20.251 2 19.9881V3.9919C2.00183 3.72957 2.10678 3.47849 2.29219 3.29289C2.47759 3.1073 2.72857 3.00209 2.9909 3H20.9869C21.5343 3 21.9778 3.44451 21.9778 3.9919V19.9881C21.976 20.2505 21.871 20.5015 21.6856 20.6871C21.5002 20.8727 21.2492 20.9779 20.9869 20.98H4.82486ZM19.98 14.9867V4.99778H3.99778V18.9822L13.9867 8.99334L19.98 14.9867ZM19.98 17.8115L13.9867 11.8182L6.82264 18.9822H19.98V17.8115ZM7.99334 10.9911C7.4635 10.9911 6.95535 10.7806 6.5807 10.406C6.20604 10.0313 5.99556 9.52318 5.99556 8.99334C5.99556 8.4635 6.20604 7.95535 6.5807 7.5807C6.95535 7.20604 7.4635 6.99556 7.99334 6.99556C8.52318 6.99556 9.03133 7.20604 9.40598 7.5807C9.78064 7.95535 9.99112 8.4635 9.99112 8.99334C9.99112 9.52318 9.78064 10.0313 9.40598 10.406C9.03133 10.7806 8.52318 10.9911 7.99334 10.9911Z",
    fill: "#323B4B",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeBackgroundIcon);
export default __webpack_public_path__ + "static/media/changeBackgroundIcon.003d79f1e378dc6bcc2ee4297d63dd93.svg";
export { ForwardRef as ReactComponent };